import React, { useState } from "react";
import { Plus } from "lucide-react";
import AddTaskDrawer from "./AddTaskDrawer";
import EditableTaskRow from "./EditableTaskRow";

/**
 * Admin Home workboard — open tasks across engagements, grouped by client.
 */
export default function AdminTodayWorkboard({
  tasks,
  clients = [],
  onToggle,
  onOpenClient,
  onAdd,
  onUpdate,
  onDelete,
}) {
  const [addOpen, setAddOpen] = useState(false);

  const groups = [];
  const index = new Map();
  tasks.forEach((t) => {
    const key = t.clientId || t.clientName || "Client";
    if (!index.has(key)) {
      index.set(key, groups.length);
      groups.push({ clientName: t.clientName || "Client", clientId: t.clientId, items: [] });
    }
    groups[index.get(key)].items.push(t);
  });

  return (
    <div className="flex min-h-0 flex-1 flex-col" data-testid="admin-tasks-v3">
      <div className="mb-2 flex shrink-0 items-center justify-end gap-2 px-0.5">
        <button
          type="button"
          onClick={() => setAddOpen(true)}
          className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.14em] text-[var(--t-accent)]"
          data-testid="admin-tasks-add"
        >
          <Plus size={12} /> Add
        </button>
      </div>

      <div className="min-h-0 flex-1 space-y-3 overflow-y-auto overscroll-contain pr-0.5">
        {groups.length === 0 ? (
          <p className="text-sm text-[var(--t-meta)]">No open tasks across engagements.</p>
        ) : (
          groups.map((g) => (
            <div key={g.clientId || g.clientName}>
              <button
                type="button"
                onClick={() => onOpenClient?.(g.items[0])}
                className="mb-1 flex w-full items-baseline justify-between text-left"
                data-testid={`admin-tasks-client-${g.clientId || g.clientName}`}
              >
                <span className="text-[11px] uppercase tracking-[0.12em] text-[var(--t-meta)]">
                  {g.clientName}
                </span>
                <span className="text-[10px] text-[var(--t-accent)]">
                  {g.items.filter((t) => !t.done).length} open
                </span>
              </button>
              <div className="space-y-0.5 border-l border-[var(--t-accent)]/25 pl-3">
                {g.items.map((t) => (
                  <EditableTaskRow
                    key={t.id}
                    task={t}
                    subtitle={t.scopeTitle}
                    onToggle={onToggle}
                    onUpdate={(patch) => onUpdate?.(t.id, patch)}
                    onDelete={onDelete ? () => onDelete(t.id) : undefined}
                    data-testid={`admin-task-v3-${t.id}`}
                  />
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      <AddTaskDrawer
        open={addOpen}
        onClose={() => setAddOpen(false)}
        eyebrow="Admin home"
        title="Add task"
        clients={clients}
        onSubmit={(payload) => onAdd?.(payload)}
        testId="admin-add-task"
      />
    </div>
  );
}
